module.exports = __webpack_public_path__ + "static/firefox-58fba07a30c6a43b2b98aaf6c7c3fd24.svg";